import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
   
    {
        path: '/',
        name: 'login',
        component: () => import('../views/Login')
    },
  
    {
        path: '/mensalidade',
        name: 'mensalidade',
        component: () => import('../views/pages/Mensalidade')
    },
    {
        path: '/dependente',
        name: 'dependente',
        component: () => import('../views/pages/Dependente')
    },
    
    {
        path: '/home',
        name: 'home',
        component: () => import('../views/pages/Home'),
        
    },
    {
        path: '/endereco',
        name: 'endereco',
        component: () => import('../views/pages/Cadastro')
    },
    
    
    {
        path: '/contato',
        name: 'contato',
        component: () => import('../views/pages/Contato')
    },
    
    {
        path: '/sinistro',
        name: 'sinistro',
        component: () => import('../views/pages/Sinistro')
    },

   

    {
        path: '/faleconosco',
        name: 'faleconosco',
        component: () => import('../views/pages/FaleConosco')
    },

    {
        path: '/privacidade',
        name: 'privacidade',
        component: () => import('../views/pages/Privacidade')

    }
]

export default new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})
